
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/errors/partner",
      function () {
        return require("private-next-pages/docs/errors/partner.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/errors/partner"])
      });
    }
  